/**
 * Employee name lookup utility
 * Maps employee IDs to display names
 */

const employeeNames = {
  "1": "Mark Herman",
  "2": "Bob Jennings",
  "8": "Trent P.",
  "9": "Chuck Chouteau",
  "10": "James Shirley",
  "11": "Shelly Buechel",
  "12": "Amber D.",
  "13": "Shannon G.",
  "14": "Paul Webster",
  "15": "Tyler Houck",
  "16": "Damon Alford",
  "22": "Shane Schwalbach",
  "23": "Jason F.",
  "24": "Gabby Pelgen",
  "25": "Chris Osborne",
  "26": "Julie Schwey",
  "27": "Mike C.",
  "28": "Ben K.",
  "29": "Michael Jacobs",
  "30": "Art Hung",
  "31": "Will Leitz",
  "32": "Isabel Huff",
  "33": "Tim Heidegger",
  "34": "Jessica Lynch",
  "35": "Sherry Gries",
  "36": "Meredith Smith",
  "40": "Savitra Sapkota",
};

export function getEmployeeNameById(employeeId) {
  if (!employeeId) return null;
  return employeeNames[String(employeeId)] || `Employee ${employeeId}`;
}

export function getAllEmployeeNames() {
  return employeeNames;
}
